import { JsonSerializable } from '../shared/jsonSerializable';

export class ThirdPartyType  extends JsonSerializable {

  code: string;
  label: string;

  constructor() {
    super();
    this.code = null;
    this.label = null;
  }

}


// WEBPACK FOOTER //
// ./src/app/entity/third-party-type.ts